import { z } from 'zod';

/**
 * Entity identifiers are opaque, URL-safe strings generated by the API
 * (time-ordered, 26 characters). Clients never construct them.
 */
export const entityIdSchema = z
    .string()
    .min(1)
    .max(64)
    .regex(/^[A-Za-z0-9_-]+$/, 'Identifier contains invalid characters');

export type EntityId = z.infer<typeof entityIdSchema>;

/**
 * Request identifiers are attached to every API response for support and log correlation.
 */
export const requestIdSchema = z.string().min(1).max(128);
